module.exports = __webpack_public_path__ + "img/img_32389_0_479.8463fed0.png";